import { Filter, FiltersType } from 'models';

const judgementFilter: Filter = {
  label: 'Judgement',
  labelUz: 'Жазо',
  value: 'Judgement',
  options: [
    { label: 'Қамоқ', labelUz: 'Қамоқ' },
    { label: 'Ҳибс', labelUz: 'Ҳибс' },
    { label: 'Руҳий шифохона', labelUz: 'Руҳий шифохона' },
    { label: 'Жарима', labelUz: 'Жарима' },
  ],
};

const accusationFilter: Filter = {
  label: 'Accusation',
  labelUz: 'Айблов',
  value: 'Accusation_B',
  options: [
    { value: 'Президентни ҳақорат', label: 'Президентни ҳақорат' },
    { value: 'Товламачилик', label: 'Товламачилик' },
    { value: 'Бошқа айбловлар', label: 'Бошқа айбловлар' },
  ],
};

const persecutionFilter: Filter = {
  label: 'Persecution',
  labelUz: 'Таъқиб',
  value: 'Persecution_B',
  options: [
    {
      value: 'Босимга учраган',
      label: 'Босимга учраган',
    },
    {
      value: 'Ҳужумга учраган',
      label: 'Ҳужумга учраган',
    },
    {
      value: 'Органга чақирув',
      label: 'Органга чақирув',
    },
    {
      value: 'Қидирувда',
      label: 'Қидирувда',
    },
  ],
};

const prohibitionFilter: Filter = {
  label: 'Prohibition',
  labelUz: 'Тақиқ',
  value: 'Prohibition',
  options: [
    {
      value: 'Фаолиятини тўхтатган',
      label: 'Фаолиятини тўхтатган',
    },
    { value: 'Блокланган', label: 'Блокланган' },
  ],
};

const exileBanFilter: Filter = {
  label: 'Exile/Ban',
  labelUz: 'Қувғин',
  value: 'Exile/Ban',
  options: [
    {
      value: 'Ўзбекистонга киритилмаган',
      label: 'Ўзбекистонга киритилмаган',
    },
    {
      value: 'Ўзбекистонни тарк этган',
      label: 'Ўзбекистонни тарк этган',
    },
    {
      value: 'Ўзбекистондан ҳайдалган',
      label: 'Ўзбекистондан ҳайдалган',
    },
  ],
};

//const commonSubfilters = [placeOfDeathFilter, dateOfDeathFilter];

export const filters: FiltersType = [
  { ...judgementFilter },
  { ...accusationFilter },
  { ...persecutionFilter },
  { ...prohibitionFilter },
  { ...exileBanFilter },
];

/*export const filters: FiltersType = [
  { ...sexFilter, subfilters: commonSubfilters },
  { ...ageFilter, subfilters: [placeOfResidenceFilter, dateOfDeathFilter] },
  { ...placeOfDeathFilter, subfilters: [ageFilter, dateOfDeathFilter] },
  { ...dateOfDeathFilter, subfilters: [ageFilter, placeOfResidenceFilter] },
  { ...placeOfResidenceFilter, subfilters: commonSubfilters },
  {
    label: 'Way of Death',
    labelKz: 'Қалай қаза тапқаны',
    labelRu: 'Обстоятельства гибели',
    value: 'Way_of_death',
    subfilters: commonSubfilters,
    options: [
      {
        labelRu: 'Во время демонстраций',
        labelKz: 'Оқиға кезінде',
      },
      {
        labelRu: 'После задержания полицией',
        labelKz: 'Полиция әкеткен соң',
      },
      { labelRu: 'В больнице', labelKz: 'Ауруханада' },
      { labelRu: 'Суицид', labelKz: 'Суицид' },
      { labelRu: 'Неизвестно', labelKz: 'Белгісіз' },
    ],
  },
  {
    label: 'Exhumed',
    labelKz: 'Эксгумацияланды',
    labelRu: 'Эксгумирован(а)',
    value: 'Exhumed',
    subfilters: commonSubfilters,
    options: [
      { labelRu: 'Да', labelKz: 'Иә' },
      { labelRu: 'Нет', labelKz: 'Жоқ' },
      { labelRu: 'Неизвестно', labelKz: 'Белгісіз' },
    ],
  },
  {
    label: 'Occupation',
    labelKz: 'Қатысушының статусы',
    labelRu: 'Статус участника/цы',
    value: 'Occupation',
    subfilters: commonSubfilters,
    options: [
      { labelRu: 'Полиция', labelKz: 'Полиция' },
      { labelRu: 'Военный', labelKz: 'Әскери' },
      { labelRu: 'КНБ', labelKz: 'ҰҚК' },
      {
        labelRu: 'Гражданское лицо',
        labelKz: 'Жеке азамат',
      },
      { labelRu: 'Неизвестно', labelKz: 'Белгісіз' },
    ],
  },
  {
    label: 'Legal status',
    labelKz: 'Құқықтық статусы',
    labelRu: 'Правовой статус',
    value: 'Legal_status',
    subfilters: commonSubfilters,
    options: [
      {
        labelRu: 'Возбуждено уголовное дело',
        labelKz: 'Әкімшілік іс қозғалды',
      },
      {
        labelRu: 'Обвинение не предъявлено',
        labelKz: 'Айып тағылмады',
      },
      { labelRu: 'Неизвестно', labelKz: 'Белгісіз' },
    ],
  },
  {
    label: 'Nationality',
    labelKz: 'Азаматтығы',
    labelRu: 'Гражданство',
    value: 'Nationality',
    subfilters: commonSubfilters,
    options: [
      { labelRu: 'Казахстан', labelKz: 'Қазақстан' },
      { labelRu: 'Ресей', labelKz: 'Ресей' },
      { labelRu: 'Кыргызстан', labelKz: 'Қырғызстан' },
      { labelRu: 'Узбекистан', labelKz: 'Өзбекстан' },
      { labelRu: 'Израиль', labelKz: 'Израиль' },
      { labelRu: 'Другие', labelKz: 'Өзге' },
    ],
  },
  {
    label: 'Underage children in family',
    labelKz: 'Кәмелетке толмаған баласы бар',
    labelRu: 'Воспитывал(а) несовершеннолетних детей',
    value: 'Underage_children_in_family',
    subfilters: commonSubfilters,
    autoSelect: true,
    options: [
      { value: 'yes', labelRu: 'Да', labelKz: 'Иә' },
      { value: 'no', labelRu: 'Нет', labelKz: 'Жоқ' },
    ],
  },
  {
    label: "Baby was born after parent's death",
    labelKz: 'Қаңтардан кейін сәбилі болды',
    labelRu: 'Ждал рождения ребенка',
    value: 'Baby_born_after_parents_death',
    subfilters: commonSubfilters,
    autoSelect: true,
    options: [
      { value: 'yes', labelRu: 'Да', labelKz: 'Иә' },
      { value: 'no', labelRu: 'Нет', labelKz: 'Жоқ' },
    ],
  },
];*/
